module.exports = __webpack_public_path__ + "static/img/servicesbg2.559cfe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/servicesbg2.jpg
// module id = a0Rz
// module chunks = 1